<div id="header" class="search-page-header" style="background-color: #006b5b;">    
    <div class="prob-header d-flex align-items-center justify-content-between flex-wrap ng-star-inserted">
        <div  class="head-row head-brand col-lg-9 col-md-9 paddingRt0 paddingLt0">
            <div  title="Home page" class="head-col logo landing-display-inline col-lg-3 col-md-3 logo-cba-pr" style="max-width: 264px;">
                <img  alt="Logo" class="b-logo cursor ng-star-inserted" width="244" height="22" src="assets/images/cba-logo.png">
            </div>
        </div>
    </div>    
</div>
<div class="content center-middle-width padding-common div-position">
    
    <img class="d-flex ml-auto mr-auto img-size" src="assets/images/thread/no-active-user.png" alt="">
    <div class="permission-text justify-content-center">
        <span class="p1">Unable to login</span>   
    <div class="p2"> For Issues Logging into Onelogin or TAC</div>
    <div class="p2"> Please submit a Support request from CBA Connect  </div>
    <br/>
    <div (click)="taponLink()" class="p2 text-class">
        Continue
    </div>


    </div>
</div>
